import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api from 'api/Api';
import { getSummariesQueryKey } from 'shared/hooks/useGetSummaries';

export const useRemoveVehicleMutation = (onSuccess: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (acquisitionName: string) =>
      Api.appraisalBff.customerReportVehicleOutcome(acquisitionName, 'MarkedRemoved'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getSummariesQueryKey(true) });
      onSuccess();
    }
  });
};
